import React from "react";
import { Navbar } from "reactstrap";

const Header = () => {
    return (
        <Navbar className="eurosport-header">
            <div className="logo">
                <img className="logo-img"
                    id="logo-eurosport"
                    alt="logo-eurosport" />
            </div>
        </Navbar >
    );
};

export default Header;
